module.exports = __webpack_public_path__ + "img/home-poster.9031d756.png";